import BottomModuleV4 from './BottomModuleV4';
import EventLineV4 from './EventLineV4';
import ModuleListV4 from './ModuleListV4';
import RewardModuleV4 from './RewardModuleV4';
import TopModuleV4 from './TopModuleV4';
import {IModuleMapV4} from '../type';

interface IProps extends Omit<IModuleMapV4, 'commonModule'> {}

export default function EventModuleListV4({
  topModule,
  rewardModule,
  moduleList,
  bottomModule,
}: IProps) {
  const hasRewardModule = !!rewardModule;
  return (
    <>
      {topModule && <TopModuleV4 data={topModule} />}
      {!hasRewardModule && <EventLineV4 hasMaxWidth />}
      {hasRewardModule && <RewardModuleV4 data={rewardModule} />}
      {moduleList && (
        <ModuleListV4
          moduleList={moduleList}
          showBetweenLine
          className="mt-40"
        />
      )}
      <div className="h-40" />
      {bottomModule && <BottomModuleV4 data={bottomModule} />}
    </>
  );
}
